document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector('form[action^="/cart/add"]');

  // nur wenn Produktseite und Form existieren
  if (!productForm) return;

  // Feldcontainer anlegen
  const customDiv = document.createElement("div");
  customDiv.innerHTML = `
    <div style="margin-top:15px;">
      <input type="checkbox" id="add-card">
      <label for="add-card">Persönliche Nachricht hinzufügen</label>
    </div>
    <div id="card-message-container" style="display:none; margin-top:10px;">
      <textarea id="card-message" placeholder="Z.B. Namen oder Grusstext..." rows="3" style="width:100%;"></textarea>
    </div>
  `;

  // anhängen unter Add‑to‑Cart‑Bereich
  const submitBtn = productForm.querySelector('button[type="submit"], .product-form__submit');
  submitBtn?.insertAdjacentElement("beforebegin", customDiv);

  const checkbox = document.getElementById("add-card");
  const messageContainer = document.getElementById("card-message-container");
  const textarea = document.getElementById("card-message");

  // Checkbox‑Handler
  checkbox.addEventListener("change", function () {
    messageContainer.style.display = checkbox.checked ? "block" : "none";
    if (!checkbox.checked) textarea.value = "";
  });

  // form submit so erweitern, dass properties mitgesendet werden
  productForm.addEventListener("submit", function (e) {
    // alte custom properties entfernen
    productForm.querySelectorAll('input[name^="properties["]').forEach(el => el.remove());

    if (checkbox.checked && textarea.value.trim() !== "") {
      const hiddenCheck = document.createElement("input");
      hiddenCheck.type = "hidden";
      hiddenCheck.name = "properties[Handgeschriebene Karte]";
      hiddenCheck.value = "Ja";
      productForm.appendChild(hiddenCheck);

      const hiddenMsg = document.createElement("input");
      hiddenMsg.type = "hidden";
      hiddenMsg.name = "properties[Nachricht für die Grusskarte]";
      hiddenMsg.value = textarea.value.trim();
      productForm.appendChild(hiddenMsg);
    }
  });
});